module.exports = __webpack_public_path__ + "static/media/Mobile-Test-Findings-042116final.015.207cdc7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/misc/Mobile-Test-Findings-042116final/Mobile-Test-Findings-042116final.015.png
// module id = 341
// module chunks = 0